import { makeSummariseDesignChange, summaryLoadingFlags } from "./actions.js";

const escapeHtml = value => String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

const hasSummary = pageItem => typeof pageItem?.aiSummary === "string" && pageItem.aiSummary.trim().length > 0;

const tagList = value => {
    if (Array.isArray(value)) return value.filter(tag => typeof tag === "string" && tag);
    if (!value || typeof value !== "object") return [];
    return Object.keys(value)
        .sort((left, right) => Number(left) - Number(right))
        .map(key => value[key])
        .filter(tag => typeof tag === "string" && tag);
};

export const makeDesignChangeSummary = (variant) => {
    const summariseDesignChange = makeSummariseDesignChange(variant);
    return {
        "label": "AI - Generated Summary",
        "key": "DesignChangeSummary",
        "local": true,
        "field": true,
        "fields": [{
            "label": "Summary",
            "class": "md:col-span-3",
            "grow": true,
            compute({ item }) {
                const text = item?.aiSummary;
                if (typeof text !== "string" || !text.trim()) return "No summary yet.";
                return escapeHtml(text).replaceAll("\n", "<br>");
            },
            get loading() {
                return function ({ item }) {
                    return summaryLoadingFlags[item?.ID] || false;
                };
            }
        }, {
            "label": "Tags",
            "class": "md:col-span-3",
            compute({ item }) {
                return escapeHtml(tagList(item?.aiTags).join(", "));
            },
            show({ item }) {
                return tagList(item?.aiTags).length > 0;
            }
        }, {
            "label": "Source",
            compute({ item }) {
                if (item?.aiSowUsed === true) return "Design change SOW";
                if (item?.aiEstimateSowUsed === true) return "Commercial estimate";
                if (hasSummary(item)) return "Record fields only";
                return "";
            },
            show({ item }) {
                return hasSummary(item);
            }
        }, {
            "label": "Warning",
            "class": "md:col-span-3",
            compute({ item }) {
                return escapeHtml(item?.aiSowWarning);
            },
            show({ item }) {
                return typeof item?.aiSowWarning === "string" && item.aiSowWarning.trim().length > 0;
            }
        }, {
            "label": "Generated",
            "key": "aiGeneratedAt",
            "type": "date",
            show({ item }) {
                return Boolean(item?.aiGeneratedAt);
            }
        }, {
            "label": "Model",
            "key": "aiModel",
            show({ item }) {
                return Boolean(item?.aiModel);
            }
        }, {
            "label": "Generated By",
            compute({ item }) {
                return escapeHtml(item?.aiCreatedBy?.Email || item?.aiCreatedBy?.UID || "");
            },
            show({ item }) {
                return Boolean(item?.aiCreatedBy?.Email || item?.aiCreatedBy?.UID);
            }
        }],
        "actions": [{
            "label": "Generate Summary",
            "action": summariseDesignChange,
            show({ pageItem }) {
                return [!hasSummary(pageItem), "A summary already exists. Use Regenerate Summary."];
            }
        }, {
            "label": "Regenerate Summary",
            "action": summariseDesignChange,
            show({ pageItem }) {
                return [hasSummary(pageItem), "Generate a summary first."];
            }
        }],
        "rowActions": []
    };
};
